var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { EGDSIconSize } from '@egds/react-core/icons';
import { PositionType } from '@egds/react-core/menu';
import { HeaderShopMenu } from '../header-shop-menu';
import { HeaderNavLobLinks } from './header-nav-lob-links';
import { getGCSectionData } from '../gc-section-data';
import { formatMenuListItems } from './util/header-nav-menu-links-util';
var SHOP_TRAVEL = 'ShopTravel';
var DEFAULT_MAX_LINK_COUNT = 5;
var HeaderNavExtendedToolbar = /** @class */ (function (_super) {
    __extends(HeaderNavExtendedToolbar, _super);
    function HeaderNavExtendedToolbar() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HeaderNavExtendedToolbar.prototype.render = function () {
        var _a;
        var _b = this.props, analytics = _b.analytics, globalComponentsContext = _b.globalComponentsContext;
        var maxLinksToDisplay = ((_a = globalComponentsContext === null || globalComponentsContext === void 0 ? void 0 : globalComponentsContext.header) === null || _a === void 0 ? void 0 : _a.navLinksMaxElements) || DEFAULT_MAX_LINK_COUNT;
        var navLinksSection = getGCSectionData(globalComponentsContext, 'header', 'navLinks');
        var lobLinks = navLinksSection && navLinksSection.sectionData.filter(function (link) { return link.type === 'link' || link.type === 'menu-v2'; });
        if (!lobLinks || !lobLinks.length) {
            return null;
        }
        var needsOverflowMenu = lobLinks.length > maxLinksToDisplay + 1;
        var numOfLobLinksToShow = needsOverflowMenu ? maxLinksToDisplay : lobLinks.length;
        var itemsDisplayed = lobLinks.slice(0, numOfLobLinksToShow).reduce(function (total, item) { return (item.type === 'menu-v2'
            ? (total + (item.data ? item.data.length : 0))
            : (total + 1)); }, 0);
        var shopTravelMenu = navLinksSection && navLinksSection.sectionData.find(function (link) { return link.id === SHOP_TRAVEL; });
        var menuItems = shopTravelMenu ? formatMenuListItems(shopTravelMenu, analytics) : [];
        var menuItemsTruncated = menuItems.length > maxLinksToDisplay ? menuItems.slice(itemsDisplayed) : [];
        var menuId = shopTravelMenu.id, menuLinkText = shopTravelMenu.text;
        return (React.createElement("nav", { id: "header-toolbar-nav-extended", className: "global-nav-header-links__nav", "aria-label": "primary" },
            React.createElement(HeaderNavLobLinks, { analytics: analytics, numberOfLinks: numOfLobLinksToShow, globalComponentsContext: globalComponentsContext }),
            needsOverflowMenu && menuItemsTruncated.length
                && (React.createElement(HeaderShopMenu, { id: "gc-custom-header-extended-tool-bar-menu", analytics: analytics, menuLinkText: menuLinkText, menuItems: menuItemsTruncated, menuId: menuId, position: PositionType.LEFT, iconSize: EGDSIconSize.MEDIUM, showAsExpandable: true }))));
    };
    HeaderNavExtendedToolbar = __decorate([
        inject('globalComponentsContext', 'analytics'),
        observer
    ], HeaderNavExtendedToolbar);
    return HeaderNavExtendedToolbar;
}(React.Component));
export { HeaderNavExtendedToolbar };
//# sourceMappingURL=header-nav-extended-toolbar.js.map